import { useParams } from 'next/navigation'

export default function useGetSlug() {
  const params = useParams<{ appealId: string; appealCategoryId: string }>()
  return {
    appealId: params?.appealId || '',
    appealCategoryId: params?.appealCategoryId || '',
  }
}
